module.exports = __webpack_public_path__ + "img/zhuanpan-zhizhen2.29b8594d.png";